import { type AxiosError, type AxiosResponse } from 'axios';

import {
  LogDevMessageKinds,
  makeLogDevMessage,
} from '@/shared/helpers/make-log-dev-message';

import { getAxiosErrorMessage } from './get-axios-error-message';
import { getBaseUrl } from './get-base-url';

const formatTitle = (response: AxiosResponse | AxiosError) => {
  const baseUrl = getBaseUrl();

  let res =
    (response.request?.responseURL ?? '').replace(baseUrl, '') ||
    (response.config?.url ?? '');

  if (baseUrl.includes('test')) {
    res = 'TEST ' + res;
  }

  return res;
};

export const logRetryInDevMode = makeLogDevMessage<AxiosError, number>(
  LogDevMessageKinds.retry,
  (error, retryCount) => formatTitle(error) + ' ~' + retryCount,
  ['MESSAGE', (error) => getAxiosErrorMessage(error)],
  ['Error', (error) => error]
);

const logResponseInDevMode = makeLogDevMessage<AxiosResponse, string>(
  LogDevMessageKinds.api,
  formatTitle,
  ['DATA', (response) => response.data]
);

export const logErrorInDevMode = makeLogDevMessage<AxiosError, string>(
  LogDevMessageKinds.apiError,
  formatTitle,
  ['MESSAGE', (error) => getAxiosErrorMessage(error)],
  ['Error', (error) => error]
);

export const apiSuccessLogger = (response: AxiosResponse) => {
  logResponseInDevMode(response);

  return Promise.resolve(response);
};

export const apiErrorLogger = (error: AxiosError) => {
  if (!error.config || !error.config['axios-retry']?.retries) {
    logErrorInDevMode(error);
  }

  return Promise.reject(error);
};
